import React from "react";
import { connect } from "react-redux";
import { notifyGeneralInfo } from "../../actions";
import axios from "axios";
import { number } from "prop-types";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";

const token = localStorage.getItem('authToken');

class AddOrganisations extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            textInput: [],
            userName: "",
            title: "",
            category: "",
            areaInput: "",
            categoryData: [],
            currentImageUrls: [],
            submissionStatus: null,
            submeet: false,
            errors: [],
            city: "",
            date: '',
            price: number,
            address: '',
            pincode: number,
            isDateValid: true,
            maxSize: 5 * 1024 * 1024, // 5MB in bytes
        };
    }

    handleChange = (e) => {
        const files = Array.from(e.target.files);
        const errors = [];

        const selectedImages = files.filter((file) => {
            const isValidSize = file.size <= this.state.maxSize;
            if (!isValidSize) {
                errors.push(`${file.name} is too large, please select a file smaller than 5MB.`);
            }
            return isValidSize;
        });

        this.setState({
            textInput: selectedImages,
            currentImageUrls: selectedImages.map((file) => URL.createObjectURL(file)), // Update current image URLs to show the new images
            errors,
        });
    };

    handleSubmit = async (e) => {
        e.preventDefault();
        this.setState({ submeet: true });

        const { textInput, date, city, title, areaInput, category, pincode, price, address } = this.state;
        try {
            const formData = new FormData();
            textInput.forEach((file, index) => {
                formData.append('images', file); // Append each file separately
            });
            formData.append('title', title);
            formData.append('description', areaInput);
            formData.append('city', city);
            formData.append('pincode', pincode);
            formData.append('price', price);
            formData.append('address', address);
            formData.append('category', category);

            const config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${token}`,
                }
            };

            const response = await axios.post("https://samaj.aasmo.in/api/admin/organisations", formData, config);

            if (response.status === 201) {
                this.setState({ submissionStatus: 'success', submeet: false });
                setTimeout(() => {
                    this.props.history.push("/organisationslist");
                }, 2000);
            }
        } catch (error) {
            console.log(error);
            this.setState({ submissionStatus: 'error' });
        }
    };

    componentWillUnmount() {
        // Revoke the object URLs to prevent memory leaks
        this.state.currentImageUrls.forEach(url => URL.revokeObjectURL(url));
    }

    render() {
        const { textInput, price, pincode, address, date, title, currentImageUrls, city, userName, category, categoryData, submeet, areaInput, submissionStatus } = this.state;
        const isTitleValid = title.trim().length > 0;
        const isCityValid = city?.trim().length > 0;

        return (
            <div className="col-md-12">
                <div className="card">
                    <div className="header">
                        <h2>Add Organisations</h2>
                    </div>
                    <div className="body">
                        <form onSubmit={this.handleSubmit}>
                            <div className="form-group">
                                <label>Title</label>
                                <input
                                    className={`form-control ${!isTitleValid && submeet && "parsley-error"}`}
                                    value={title}
                                    name="title"
                                    required=""
                                    type="text"
                                    onChange={(e) => {
                                        this.setState({ title: e.target.value });
                                    }}
                                />
                                {!isTitleValid && submeet ? (
                                    <ul className="parsley-errors-list filled">
                                        <li className="parsley-required">
                                            This value is required.
                                        </li>
                                    </ul>
                                ) : null}
                            </div>

                            <div className="form-group">
                                <label>Image</label>

                                {currentImageUrls.map((imageUrl, index) => (
                                    <div key={index}>
                                        <img src={imageUrl} alt={`Image ${index}`} style={{ width: '100px', marginBottom: '10px' }} />
                                    </div>
                                ))}

                                <input
                                    type="file"
                                    className={`form-control ${!textInput.length && submeet && "parsley-error"}`}
                                    name="textInput"
                                    required=""
                                    multiple
                                    onChange={this.handleChange}
                                />
                                {!textInput.length && submeet ? (
                                    <ul className="parsley-errors-list filled">
                                        <li className="parsley-required">This value is required.</li>
                                    </ul>
                                ) : null}
                            </div>

                            <div className="form-group">
                                <label>City</label>
                                <input
                                    className={`form-control ${!isCityValid && submeet && "parsley-error"}`}
                                    value={city}
                                    name="city"
                                    required=""
                                    type="text"
                                    onChange={(e) => {
                                        this.setState({ city: e.target.value });
                                    }}
                                />
                                {!isCityValid && submeet ? (
                                    <ul className="parsley-errors-list filled">
                                        <li className="parsley-required">
                                            This value is required.
                                        </li>
                                    </ul>
                                ) : null}
                            </div>

                            <div className="form-group">
                                <label>Description</label>
                                <textarea
                                    className={`form-control ${areaInput === "" && submeet && "parsley-error"
                                        }`}
                                    value={areaInput}
                                    cols="30"
                                    name="textarea"
                                    required=""
                                    rows="5"
                                    onChange={(e) => {
                                        this.setState({ areaInput: e.target.value });
                                    }}
                                ></textarea>
                                {areaInput === "" && submeet ? (
                                    <ul className="parsley-errors-list filled" id="parsley-id-29">
                                        <li className="parsley-required">
                                            This value is required.
                                        </li>
                                    </ul>
                                ) : null}
                            </div>

                            {submissionStatus === 'success' && (
                                <div className="alert alert-success" role="alert">
                                    Form submitted successfully!
                                </div>
                            )}

                            <button className="btn btn-primary" type="submit">
                                Submit
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ mailInboxReducer }) => ({});

export default withRouter(connect(mapStateToProps, { notifyGeneralInfo })(AddOrganisations));
